import type { LanguageCode } from '../game/types'
import { translateStatic } from '../i18n/translate'

export function friendlySyncError(
  error: unknown,
  lang: LanguageCode,
): string {
  const raw =
    error instanceof Error ? error.message : typeof error === 'string' ? error : ''

  if (
    raw.includes('profiles_id_fkey') ||
    raw.includes('23503') ||
    /foreign key constraint.*profiles/i.test(raw)
  ) {
    return translateStatic(lang, 'sync_err_stale_session')
  }

  return raw || translateStatic(lang, 'sync_err_generic')
}
